/* eslint-disable implicit-arrow-linebreak */
import tinycolor from 'tinycolor2';

import { Theme, defaultTheme } from './theme.css';

declare const window: {
  THEME_DERIVED_VALUES: Record<string, ThemeDerivedEntry>;
} & Window;

type ColorMode = 'brighten' | 'darken' | 'lighten';

type ColorKey = keyof Theme['palette']

type ThemeDerivedEntry = {
  key: ColorKey;
  mode: ColorMode;
  amount: number;
}

const getThemeColorMode = (mode: ColorMode, key: ColorKey, amount: number) => {
  const themeColorKey = `--theme-${key}-color`;
  const themeColorModeKey = `--theme-${key}-color-${mode}-${amount}`;
  const getColorValue = getComputedStyle(document.documentElement);
  const precomputedColor = getColorValue.getPropertyValue(themeColorModeKey);
  if (!precomputedColor) {
    const color = getColorValue.getPropertyValue(themeColorKey);
    const rgb = tinycolor(`rgb(${color})`)[mode](amount).toRgb();
    const rgbString = `${rgb.r}, ${rgb.g}, ${rgb.b}`;

    if (window.THEME_DERIVED_VALUES) {
      window.THEME_DERIVED_VALUES[themeColorModeKey] = { key, mode, amount };
    } else {
      window.THEME_DERIVED_VALUES = { [themeColorModeKey]: { key, mode, amount } };
    }

    document.documentElement.style.setProperty(themeColorModeKey, rgbString);
  }
  return `rgb(var(${themeColorModeKey}))`;
};

export const getThemeColor = (key: ColorKey, alpha: string | number = 1) =>
 `rgba(var(--theme-${key}-color), ${alpha})`;

export const getThemeColorBrighter = (key: ColorKey, amount: number) => getThemeColorMode('brighten', key, amount);

export const getThemeColorDarker = (key: ColorKey, amount: number) => getThemeColorMode('darken', key, amount);

export const getThemeColorLighter = (key: ColorKey, amount: number) => getThemeColorMode('lighten', key, amount);

export const theme = defaultTheme;
